import { notification } from 'antd'
import { getLoggedInUserInfo } from 'utils'
import apiClient from '../index'

export const uploadDocument = (data) => apiClient.post('media', data)
export const candidateUploadDocument = (data) => apiClient.post('media/candidateDocUpload', data)
export const updateCandidateDocument = (data) => apiClient.patch('media/updateCandidateMedia', data)
export const updateDocument = (data) => apiClient.patch('media/updateMedia', data)
export const uploadAprExcel = (data) => apiClient.post('attendance/uploadApr', data)
export const uploadAttendanceExcel = (data) => apiClient.post('attendance/markAttendance', data)
export const uploadAcknowledgementDocument = (data) => apiClient.post('acknowledgement', data)
export const uploadSignDocument = (data) => apiClient.patch('acknowledgement/uploadSignDoc', data)
export const getAckDocStatus = ({ skip, limit }, id, filter) => {
  return apiClient.get(`acknowledgement/${id}`, {
    params: {
      skip,
      limit,
      ackStatus: filter?.ackStatus,
      text: filter?.text,
    },
  })
}
export const updateStatusForAckDoc = (id, status) => {
  return apiClient.patch(`acknowledgement/updateAckDocStatus/${id}`, { status })
}

export const getAckDoc = ({ skip, limit, ackStatus }) => {
  return apiClient.get('acknowledgement', {
    params: {
      skip,
      limit,
      ackStatus,
    },
  })
}

export const getDocument = async (mediaType, year, searchEmployee, skip, limit) => {
  // const empId = getLoggedInUserInfo()?.empId
  // const userId = getLoggedInUserInfo()?.userId
  try {
    return await apiClient.get('/media', {
      params: {
        mediaType,
        year,
        skip,
        limit,
        searchEmployee,
        // userId,
        // empId,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}

export const deleteDocument = async (id) => {
  const empId = getLoggedInUserInfo()?.empId
  try {
    return await apiClient.delete('media/documentDelete', {
      params: {
        id,
        empId,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}

export const salarySlip = async (value) => {
  const empId = getLoggedInUserInfo()?.empId
  const userRole = getLoggedInUserInfo()?.userRole
  const { mediaType, year } = value
  try {
    return apiClient.get('media/salarySlip', {
      params: {
        empId,
        mediaType,
        year,
        userRole,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
